import { ReactElement } from 'react';

import * as graphql from 'generated/graphql';

import CompetencyModal from './modals/CompetencyModal';
import OpenQuestionModal from './modals/OpenQuestionModal';
import ParagraphModal from './modals/ParagraphModal';
import SentimentModal from './modals/SentimentModal';
import StarsModal from './modals/StarsModal';
import TitleModal from './modals/TitleModal';
import SignatureModal from './modals/SignatureModal';
import FinalScoreModal from './modals/FinalScoreModal';
import ReviewGoalsModal from './modals/ReviewGoalsModal';

import { pickEvaluationSectionItem } from '../utilities/pickEvaluationSectionItem';
import DevelopmentPlanModal from './modals/DevelopmentPlanModal';

export default function EditModal(props: {
	item: graphql.EvaluationSectionItem;
	onUpdate: (id: string, item?: graphql.EvaluationSectionItem) => void;
}): ReactElement {
	const modal = pickEvaluationSectionItem<() => React.ReactElement>(props.item, {
		competency: () => (
			<CompetencyModal
				fillInBy={props.item.fillInBy}
				item={props.item.competency!}
				onChange={(competency, fillInBy) => {
					props.onUpdate(props.item.id, {
						...props.item,
						competency,
						fillInBy,
					});
				}}
			/>
		),

		openQuestion: () => (
			<OpenQuestionModal
				fillInBy={props.item.fillInBy}
				item={props.item.openQuestion!}
				onChange={(openQuestion, fillInBy) =>
					props.onUpdate(props.item.id, {
						...props.item,
						openQuestion,
						fillInBy,
					})
				}
			/>
		),

		sentiment: () => (
			<SentimentModal
				fillInBy={props.item.fillInBy}
				item={props.item.sentiment!}
				onChange={(sentiment, fillInBy) =>
					props.onUpdate(props.item.id, {
						...props.item,
						sentiment,
						fillInBy,
					})
				}
			/>
		),

		signature: () => (
			<SignatureModal
				fillInBy={props.item.fillInBy}
				item={props.item.signature!}
				onChange={(signature, fillInBy) =>
					props.onUpdate(props.item.id, {
						...props.item,
						signature,
						fillInBy,
					})
				}
			/>
		),

		stars: () => (
			<StarsModal
				fillInBy={props.item.fillInBy}
				item={props.item.stars!}
				onChange={(stars, fillInBy) =>
					props.onUpdate(props.item.id, {
						...props.item,
						stars,
						fillInBy,
					})
				}
			/>
		),

		title: () => (
			<TitleModal
				fillInBy={props.item.fillInBy}
				item={props.item.title!}
				onChange={(title, fillInBy) =>
					props.onUpdate(props.item.id, {
						...props.item,
						title,
						fillInBy,
					})
				}
			/>
		),

		paragraph: () => (
			<ParagraphModal
				fillInBy={props.item.fillInBy}
				item={props.item.paragraph!}
				onChange={(paragraph, fillInBy) =>
					props.onUpdate(
						props.item.id,
						paragraph
							? {
									...props.item,
									paragraph,
									fillInBy,
							  }
							: undefined,
					)
				}
			/>
		),

		finalScore: () => (
			<FinalScoreModal
				fillInBy={props.item.fillInBy}
				item={props.item.finalScore!}
				onChange={(finalScore, fillInBy) =>
					props.onUpdate(props.item.id, {
						...props.item,
						finalScore,
						fillInBy,
					})
				}
			/>
		),

		reviewGoals: () => (
			<ReviewGoalsModal
				fillInBy={props.item.fillInBy}
				item={props.item.reviewGoals!}
				onChange={(reviewGoals, fillInBy) =>
					props.onUpdate(props.item.id, {
						...props.item,
						reviewGoals,
						fillInBy,
					})
				}
			/>
		),

		developmentPlan: () => (
			<DevelopmentPlanModal
				fillInBy={props.item.fillInBy}
				item={props.item.developmentPlan!}
				onChange={(developmentPlan, fillInBy) =>
					props.onUpdate(props.item.id, {
						...props.item,
						developmentPlan,
						fillInBy,
					})
				}
			/>
		),
	});

	return modal();
}
